<template>
  <div
    class="ag-page_policy-review-checklist position-relative"
    :class="route.meta.title"
  >
    <ag-card
      :module="module"
      :key="store.getters.compKey"
      @search="search"
      @main="mainLink"
    ></ag-card>
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";
import AgCard from "@/components/ag-card/index.vue";
import PolicyReviewChecklist from "@/helpers/pages/PolicyReviewChecklist";
import api from "@/store/axiosAgsc";
import moment from "moment";
import { useStore } from "@/store";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { useRoute } from "vue-router";
import Swal from "sweetalert2";
import router from "./../../router";
import { useCommonStore } from "@/stores/common";
export default defineComponent({
  name: "PolicyReviewChecklist",
  data() {
    return {
      tempData: {
        total: 0,
        rows: [],
      },
    };
  },
  setup() {
    const route = useRoute();
    const module = ref(PolicyReviewChecklist);
    const store = useStore();

    const setFilterStatus = () => {
      store.dispatch(GeneralActionTypes.FILTER_STATUS, false);
    };
    let filter = ref({
      page: 1,
      limit: 20,
      startDate: moment().utc().startOf("day").subtract(7, "days"),
      endDate: moment().utc(),
      decisionId: 1,
      decisionStatusId: 1,
    });

    const RESETFILTER = filter;
    const getList = async (
      filters = filter.value,
      options = module.value.component.options,
      type = 'standart'
    ) => {
      // let currentStatus;

      // switch (route.meta.title) {
      //   case "draftreviews":
      //     currentStatus = reviewStatuses?.filter((i) => {
      //       return i.key == "Draft";
      //     })[0].value;
      //     break;

      //   case "completed":
      //     currentStatus = reviewStatuses?.filter((i) => {
      //       return i.key == "Complete";
      //     })[0].value;
      //     break;

      //   case "deleted":
      //     currentStatus = reviewStatuses?.filter((i) => {
      //       return i.key == "Delete";
      //     })[0].value;
      //     break;
      // }
      if (route.fullPath.indexOf("drafted") > -1) {
        filters.decisionId = 1;
        filters.decisionStatusId = 1;
        filters.Status = 1;
        filters.Decision = 1;
      } else if (route.fullPath.indexOf("applied") > -1) {
        filters.decisionId = 1;
        filters.decisionStatusId = 2;
        filters.Status = 2;
        filters.Decision = 1;
      } else if (route.fullPath.indexOf("published") > -1) {
        filters.decisionId = 1;
        filters.decisionStatusId = 3;
        filters.Status = 3;
        filters.Decision = 1;
      } else {
        filters.decisionId = 2;
        filters.decisionStatusId = 1;
        filters.Status = 1;
        filters.Decision = 2;
      }
      module.value.component.decisionId = filters.decisionId;
      module.value.component.decisionStatusId = filters.decisionStatusId;
      const body = { filters, options };

      if(type == 'search') {
        delete filters.decisionId ;
        delete filters.decisionStatusId ;
        store.dispatch(GeneralActionTypes.GET_PROPOSED_UNIQUE_BLOCKS, body);
      }else {
        store.dispatch(GeneralActionTypes.GET_REVIEW_CHECK_LIST, body);
      }
    };

    const searchWithFilters = (param) => {
    const commonStore = useCommonStore();
  filter.value.action =
    module.value.filter.filters.filter((x) => x.title == "action")[0]
    .vmodel || "";
  filter.value.mode =
    module.value.filter.filters.filter((x) => x.title == "mode")[0]
    .vmodel || "";
  filter.value.status =
    module.value.filter.filters.filter((x) => x.title == "status")[0]
    .vmodel || "0";
  filter.value.decision =
    module.value.filter.filters.filter((x) => x.title == "decision")[0]
    .vmodel || "";

  if (commonStore.dateFilter && commonStore.dateFilter.value) {
    filter.value.startDate = commonStore.dateFilter.value;
    filter.value.endDate = moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS");
  }

  const filters = filter.value;
  const options = module.value.component.options;
  module.value.readyToUseFilters = filters;
  if (options.readyToUseFilters) {
    module.value.readyToUseFilters = options.readyToUseFilters;
    options.page = 1;
    filters.policyFileVersion = options.readyToUseFilters.policyFileVersion;
    filters.policyFileVersionLimit = options.readyToUseFilters.policyFileVersionLimit;
    filters.startDate = filter.value.startDate;
    filters.endDate = filter.value.endDate;
  }
  getList(filters, options, 'search');
  if (!param) {
    router.push({ query: { searchResults: "true" } });
  }
  module.value.component.options.isSearchMode = true;
  module.value.component.options.currentSearchFilters = { ...filter.value };
};

    const resetFilters = () => {
      module.value.filter.filters.forEach((item) => {
        item.vmodel = null;
      });
      searchWithFilters(true);
      let query = Object.assign({}, router.currentRoute.value.query);
      delete query.searchResults;
      router.replace({ query });
    };

    return {
      setFilterStatus,
      searchWithFilters,
      resetFilters,
      filter,
      getList,
      module,
      store,
      route,
    };
  },
  mounted() {
    this.setFilterStatus();
    const filters = this.filter;
    const options = this.module.component.options;
    this.getList(filters, options);
  },
  methods: {
    deleteFunction(id) {
      Swal.fire({
        title: "Are You Sure?",
        icon: "warning",
        text: "You are about to delete the selected item!",
        showCancelButton: true,
        confirmButtonText: "Delete",
      }).then((result) => {
        if (result.isConfirmed) {
          api
            .post("PolicyReview/DeleteProposedUniqueBlock?id=" + id)
            .finally(() => {
              const filters = this.filter;
              const options = this.module.component.options;
              this.getList(filters, options);
            });
        }
      });
    },
    mainLink() {
  if (this.tempData.total > 0) {
    this.module.component.options.rows = this.tempData.rows;
    this.module.component.options.total = this.tempData.total;
  } else {
    const filters = this.filter;
    this.module.readyToUseFilters = filters;
    const options = this.module.component.options;
    this.module.component.options.isSearchMode = false;
    this.getList(filters, options, 'search');
  }
},
   search() {
  this.tempData.rows = this.module.component.options.rows;
  this.tempData.total = this.module.component.options.total;
  this.module.component.options.rows = [];
  this.module.component.options.total = 0;
  this.module.filter.filters.forEach((item) => {
    item.vmodel = null;
  });
  this.filter.action = "";
  this.filter.mode = "";
  this.filter.status = 0;
  this.filter.decision = "";
},
  },
  components: { AgCard },
 watch: {
 "$route.fullPath"(newValue, oldValue) {
  this.setFilterStatus();
  if (this.$route.query.searchResults) {
    this.searchWithFilters(true);
    return;
  }

  this.module.filter.filters.forEach((item) => {
    item.vmodel = null;
  });
  this.filter.action = "";
  this.filter.mode = "";
  this.filter.status = 0;
  this.filter.decision = "";
  this.module.component.options.isSearchMode = false;
  this.module.component.options.currentSearchFilters = null;
  this.tempData = { total: 0, rows: [] };

  const commonStore = useCommonStore();
  const filters = this.filter;
  if (commonStore.dateFilter && commonStore.dateFilter.value) {
    filters.startDate = commonStore.dateFilter.value;
    filters.endDate = moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS");
  }
  this.module.readyToUseFilters = filters;
  const options = this.module.component.options;
  options.page = 1;
  this.getList(filters, options, 'standart');
},
  "store.getters.compKey"(newValue, oldValue) {
    const filters = this.filter;
    this.module.readyToUseFilters = filters;
    const options = this.module.component.options;
    options.page = 1;
    filters.page = 1;
    this.getList(filters, options);
  },
},
});
</script>


<style scoped>
.ag-card_buttons > div:nth-of-type(1) {
  display: none;
}
</style>

<style>
.ag-page_policy-review-checklist .ag-badge {
  line-height: auto;
  margin-left: 8px;
  padding: 0.25em 0.4em !important;
  display: flex;
  align-items: center;
  border-radius: 2px !important;
}

.ag-page_policy-review-checklist .badge-success {
  background: #85933f !important;
}

.ag-page_policy-review-checklist .badge-warning {
  background: #ec9f04 !important;
}

.ag-page_policy-review-checklist .badge-danger {
  background: #bf3000 !important;
}

.ag-page_policy-review-checklist #ag-table .table td {
  padding: 0.75em;
  line-height: 20px;
}

/* .ag-page_policy-review-checklist #ag-table .table tr > td:nth-child(5), */
.ag-page_policy-review-checklist #ag-table .table tr > td:nth-child(6) {
  color: #4c8dbb;
  font-size: 0.9em;
}

.ag-page_policy-review-checklist .ag-card_header {
  box-shadow: none;
  -webkit-box-shadow: none;
}

.ag-page_policy-review-checklist .ag-card_title {
  color: #4c8dbb;
  font-size: 20px;
  font-weight: 600;
  padding: 25px;
  margin: 0 !important;
  position: relative;
}

.ag-page_policy-review-checklist .ag-card_title::after {
  content: "";
  left: 0;
  bottom: -2.5px;
  width: 100%;
  height: 5px;
  background-color: #1878af;
  border-radius: 14px;
  position: absolute;
}

.ag-page_policy-review-checklist #ag-table .table td {
  border-color: #b7c6cd;
  word-break: break-word;
  font-size: 15px;
  line-height: 24px;
  max-width: 330px;
}

.ag-page_policy-review-checklist #ag-table .table td:nth-child(1),
.ag-page_policy-review-checklist #ag-table .table td:nth-child(2) {
  word-break: inherit;
}

.ag-ancestor-list .table td:nth-child(1) {
  word-break: break-word !important;
}

.ag-page_policy-review-checklist #ag-table .table th {
  color: #3a3a3a;
  font-size: 12px;
  padding: 0.75rem;
  word-break: break-all;
}

.ag-page_policy-review-checklist #ag-table .ag-icon_expand {
  position: relative;
  /* display: none; */
}

.ag-page_policy-review-checklist
  #ag-table
  a[data-target="#exampleModalCenter"] {
  text-decoration: none;
}

.ag-page_policy-review-checklist
  #ag-table
  a[data-target="#exampleModalCenter"] {
  background: url("~@/assets/icons/edit.svg") center center no-repeat;
  width: 24px;
  height: 24px;
  margin-top: 4px;
}

.ag-page_policy-review-checklist.Applied
  #ag-table
  a[data-target="#exampleModalCenter"],
.ag-page_policy-review-checklist.Published
  #ag-table
  a[data-target="#exampleModalCenter"] {
  background: url("~@/assets/icons/eye.svg") center center no-repeat;
  width: 24px;
  height: 24px;
  margin-top: 4px;
}

.show-icon {
  background: url("~@/assets/icons/eye.svg") center center no-repeat !important;
}

.ag-page_policy-review-checklist
  #ag-table
  a[data-target="#exampleModalCenter"]
  .ag-icon_expand {
  display: none;
}
</style>
